import { reactive, computed } from 'vue'

/**
 * Creates a data pager
 *
 * @param rowsCount The number of rows for which this pager is "responsible"
 */
export function usePager(rowsCount: number) {
  const pager = reactive({
    rowsCount: rowsCount,
    rowsPerPage: 20,
    pageCurrent: 1,
    pageMin: 1,
    pageMax: computed(() => {
      const f = Math.trunc(pager.rowsCount / pager.rowsPerPage)
      return (pager.rowsCount - (f * pager.rowsPerPage)) > 0 ? f + 1 : f
    }),
    pageRowStart: computed(() => {
      const min = (pager.pageCurrent - 1) * pager.rowsPerPage + 1
      return pager.rowsCount > 0 ? min : 0
    }),
    pageRowEnd: computed(() => {
      const max = pager.pageCurrent * pager.rowsPerPage
      return max > pager.rowsCount ? pager.rowsCount : max
    }),
    criteria: []
  });

  const pagerUpdatePageCurrent = (value: number) => {
    if (value === pager.pageCurrent) return

    pager.pageCurrent = value
  };

  const pagerUpdateRowsPerPage = (value: number) => {
    if (value === pager.rowsPerPage) return

    pager.rowsPerPage = value
  };

  const pagerUpdateRowsCount = (value: number) => {
    if (value === pager.rowsCount) return

    pager.rowsCount = value
  };

  const pagerUpdateCriteria = (value: any) => {
    pager.criteria = value
  };

  return {
    pager,
    pagerUpdatePageCurrent,
    pagerUpdateRowsPerPage,
    pagerUpdateRowsCount,
    pagerUpdateCriteria
  }
}
